import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getCompany } from "../api/crud";
const MergeCompany = ({
  companySource,

  companyTarget,
  setCompanyTarget,
}) => {
  const [optionsCompany, setOptionsCompany] = useState([]);

  const getCompanyList = async () => {
    getCompany()
      .then((res) => {
        console.log(res);
        const list = res
          .map((company) => {
            return {
              label: `${company.id} : ${company.name}`,
              value: company.id,
              data: company,
            };
          })
          .filter(
            (el) => el.value !== companySource.id && el.data.waiting == "0"
          );

        setOptionsCompany(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (companySource) {
      getCompanyList();
    }
  }, [companySource]);

  return (
    <div>
      <form action="./merge-company.php" method="post">
        <div className="row">
          <div className="col">
            <div>{companySource?.name}</div>
            <div>
              <ol>
                {companySource?.st_object?.map((st) => {
                  return (
                    <li>
                      {st?.st__st_name}
                      <input
                        name="st_id[]"
                        value={st?.st__st_id}
                        className="d-none"
                      />
                    </li>
                  );
                })}
              </ol>
            </div>
          </div>
          <div className="col">
            <Select
              options={optionsCompany}
              onChange={(ev) => {
                setCompanyTarget(ev);
              }}
              value={companyTarget}
            />
            <input name="cp_id" value={companySource?.id} className="d-none" />
            <input
              name="cp_target"
              value={companyTarget?.value}
              className="d-none"
            />
          </div>
        </div>

        <button
          className="btn btn-primary"
          type="submit"
          disabled={companyTarget ? false : true}
        >
          ยืนยัน
        </button>
      </form>
    </div>
  );
};

export default MergeCompany;
